const wiki = {
  search: "Поиск в вики...",
  allCategories: "Все категории",
  newEntry: "Новая запись",
  noEntries: "Нет записей в вики",
  noEntriesDesc: "Создайте первую запись для построения базы знаний",
  noResults: "Ничего не найдено",
  tryDifferentSearch: "Попробуйте другие слова для поиска",
  title: "Заголовок",
  description: "Описание",
  category: "Категория",
  qaPairs: "Вопросы и ответы",
  question: "Вопрос",
  answer: "Ответ",
  addQaPair: "Добавить вопрос и ответ",
  removeQaPair: "Удалить",
  save: "Сохранить",
  saving: "Сохранение...",
  saved: "Сохранено",
  cancel: "Отмена",
  create: "Создать запись",
  creating: "Создание...",
  backToWiki: "Назад к вики",
  editEntry: "Редактировать запись",
  deleteEntry: "Удалить запись",
  confirmDelete: "Удалить запись навсегда?",
  entries: "записей",
  lastUpdated: "Последнее обновление",
  uncategorized: "Без категории",
  titleRequired: "Заголовок обязателен",
  categories: {
    sales: "Продажи",
    ops: "Операции",
    tech: "Технологии",
    people: "Люди",
    products: "Продукты",
  },
} as const;
export default wiki;
